export default "__VITE_ASSET__25d131da__"